import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import { AuthProvider, useAuth } from "./context/AuthContext";

// Public pages
import EiraaHeader from "./components/EiraaHeader";
import EiraaHero from "./components/EiraaHero";
import EiraaAbout from "./components/EiraaAbout";
import EiraaProducts from "./components/EiraaProducts";
import EiraaFeatures from "./components/EiraaFeatures";
import EiraaBenefits from "./components/EiraaBenefits";
import EiraaContact from "./components/EiraaContact";
import EiraaFooter from "./components/EiraaFooter";

// Admin pages
import AdminLogin from "./pages/admin/Login";
import AdminLayout from "./pages/admin/AdminLayout";
import Dashboard from "./pages/admin/Dashboard";
import ProductsAdmin from "./pages/admin/Products";
import ContactsAdmin from "./pages/admin/Contacts";
import CompanyInfoAdmin from "./pages/admin/CompanyInfo";
import SettingsAdmin from "./pages/admin/Settings";

// Public website component
const PublicWebsite = () => (
  <>
    <EiraaHeader />
    <main>
      <EiraaHero />
      <EiraaAbout />
      <EiraaProducts />
      <EiraaFeatures />
      <EiraaBenefits />
      <EiraaContact />
    </main>
    <EiraaFooter />
  </>
);

// Protected route wrapper
const ProtectedRoute = ({ children }) => {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="text-gray-600">Loading...</div>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/admin/login" replace />;
  }

  return children;
};

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <div className="App">
          <Routes>
            {/* Public Routes */}
            <Route path="/" element={<PublicWebsite />} />
            
            {/* Admin Routes */}
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route
              path="/admin"
              element={
                <ProtectedRoute>
                  <AdminLayout />
                </ProtectedRoute>
              }
            >
              <Route index element={<Navigate to="/admin/dashboard" replace />} />
              <Route path="dashboard" element={<Dashboard />} />
              <Route path="products" element={<ProductsAdmin />} />
              <Route path="contacts" element={<ContactsAdmin />} />
              <Route path="company" element={<CompanyInfoAdmin />} />
              <Route path="settings" element={<SettingsAdmin />} />
            </Route>

            {/* Catch all */}
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
          <Toaster />
        </div>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;